"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RatingStatefulOption = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _color = _interopRequireDefault(require("../../constants/color"));

var _ratingOption = _interopRequireDefault(require("./ratingOption"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var RatingStatefulOption = function RatingStatefulOption(_ref) {
  var props = _extends({}, _ref);

  return _react.default.createElement(_ratingOption.default, props);
};

exports.RatingStatefulOption = RatingStatefulOption;
RatingStatefulOption.displayName = 'RatingStateful.Option';
RatingStatefulOption.propTypes = {
  children: _propTypes.any.isRequired,
  id: _propTypes.string,
  value: _propTypes.any,
  name: _propTypes.string,
  selected: _propTypes.bool,

  /** {const} One of: @@Color.background.orange[700]@@ @@Color.background.orange[500]@@ @@Color.background.yellow[600]@@ @@Color.background.green[500]@@ @@Color.background.green[700]@@ @@Color.background.gray[600]@@ */
  backgroundColor: (0, _propTypes.oneOf)([_color.default.background.orange[700], _color.default.background.orange[500], _color.default.background.yellow[600], _color.default.background.green[500], _color.default.background.green[700], _color.default.background.gray[600]]),
  onChange: _propTypes.func,
  onMouseEnter: _propTypes.func
};
var _default = RatingStatefulOption;
exports.default = _default;
RatingStatefulOption.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "RatingStateful.Option",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "selected": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "backgroundColor": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "Color.background.orange[700]",
          "computed": true
        }, {
          "value": "Color.background.orange[500]",
          "computed": true
        }, {
          "value": "Color.background.yellow[600]",
          "computed": true
        }, {
          "value": "Color.background.green[500]",
          "computed": true
        }, {
          "value": "Color.background.green[700]",
          "computed": true
        }, {
          "value": "Color.background.gray[600]",
          "computed": true
        }]
      },
      "required": false,
      "description": "{const} One of: @@Color.background.orange[700]@@ @@Color.background.orange[500]@@ @@Color.background.yellow[600]@@ @@Color.background.green[500]@@ @@Color.background.green[700]@@ @@Color.background.gray[600]@@"
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};